/* eslint-disable @typescript-eslint/no-explicit-any */
export interface Suggestion<T> {
  label: string;
  value: T;
  searchKeys?: (keyof T)[] | unknown;
}

export const isSuggestion = <T>(input: any): input is Suggestion<T> =>
  input && (input as Suggestion<T>).label !== undefined && (input as Suggestion<T>).value !== undefined;

export const getFullnameSuggestion = <T extends { fullname: string }>(entity: T): Suggestion<T> => ({
  label: entity.fullname,
  value: entity,
});
